// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"192":"ed764b2c","663":"ed764b2c","779":"b56cb73e","806":"ed764b2c"}[chunkId] + ".css";
};